<template>
  <div id="contenedor-presupuestos-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'PresupuestosMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
